module.exports = __webpack_public_path__ + "811c8baeca3bb3329488f729979c1fbc.woff";


//////////////////
// WEBPACK FOOTER
// ./~/opensans-npm-webfont/fonts/opensans.woff
// module id = 668
// module chunks = 57